import React from "react";
import PropTypes from "prop-types";

import Button from "common-components/Buttons";
import Modal from "common-components/Modal/Modal";
import { replaceHashValues } from "utils/replaceHashValues";
import { ModalTitle, ModalBody, ModalFooter } from "@vds/modals";

const CancelRequestModal = ({
  handleClick,
  handleCancelClick,
  downloadRequestDate,
  dateOfRequest,
  modalContent,
  ...props
}) => {
  return (
    <Modal contentLabel="cancel request modal">
       <ModalTitle>  <h2 style={{ marginTop: "25px", maxWidth: "349px", marginBottom: "35px" }}>{modalContent.section_title}</h2> </ModalTitle>
      <ModalBody>
        <p style={{ marginBottom: "35px" }}>
          {replaceHashValues(modalContent.section_description, {
            dateOfRequest: downloadRequestDate || dateOfRequest
          })}
        </p>      
      </ModalBody>
      <ModalFooter
      buttonData={{
        primary: {
          width: '100%',
          children: modalContent.buttons[0].text,
          onClick: () => handleClick("cancel")
          // background={modalContent.buttons[0].type}
        },
        close: {
          width: '100%',
          children: modalContent.buttons[1].text,
          onClick: () => handleCancelClick()
        },
      }}
    />
    </Modal >

  );
};

export default CancelRequestModal;

CancelRequestModal.propTypes = {
  handleClick: PropTypes.func.isRequired,
  handleCancelClick: PropTypes.func.isRequired
};
